import React, { ReactNode } from "react";
import Modal from "../Modal";
import MtiButton, { MTIButtonProps } from "../../Buttons/MtiButton";

import styles from "./MtiModalIllustration.module.css";

interface MtiModalIllustrationProps {
  title?: ReactNode;
  icon?: ReactNode;
  message?: ReactNode;
  description?: ReactNode;
  open: boolean;
  onCancel: () => void;
  buttons?: MTIButtonProps[];
}

function MtiModalIllustration(props: Readonly<MtiModalIllustrationProps>) {
  const { open, onCancel, icon, title, message, description, buttons } = props;
  return (
    <Modal
      show={open}
      onHide={onCancel}
      hideOnBackdropClick
      className={styles.modal}
    >
      <header>{!!title && <h2 className={styles.title}>{title}</h2>}</header>
      <main className={styles.main}>
        {!!icon && icon}

        {(!!message || !!description) && (
          <div className={styles.mainBody}>
            {!!message && <h3 className={styles.message}>{message}</h3>}
            {!!(<p>{description}</p>) && (
              <p className={styles.description}>{description}</p>
            )}
          </div>
        )}
      </main>
      {!!buttons && (
        <footer className={styles.footer}>
          {buttons.map((props) => (
            <MtiButton size="large" {...props} />
          ))}
        </footer>
      )}
    </Modal>
  );
}

export default MtiModalIllustration;
